<template>
  <div>
    <form data-vv-scope="flow-part-1">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Datos para el flujo del Estado de Pago</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Nombre para el flujo (*)"
            maxlength="120"
            name="name"
            v-model="step.name"
            :danger="errors.has('flow-part-1.name')"
            :danger-text="errors.first('flow-part-1.name')"
            v-validate="'required'"
          />
        </div>
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Descripción para el flujo (*)"
            name="description"
            v-model="step.description"
            :danger="errors.has('flow-part-1.description')"
            :danger-text="errors.first('flow-part-1.description')"
            v-validate="'required'"
            maxlength="550"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Monto"
            name="amount"
            type="number"
            v-model="step.amount"
            :danger="errors.has('flow-part-1.amount')"
            :danger-text="errors.first('flow-part-1.amount')"
            v-validate="{ required: step.executionType === 'P' }"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3">
          <UploadFile
            permission="*"
            accept="application/pdf"
            text="Cargar Carátula"
            v-model="step.mainFile"
            upload-to="ed"
            :button-class="{ 'btn-block': true, 'mb-5': errors.has('flow-part-1.mainFileName') }"
            container-class="w-100"
            @input="addFile()"
          />
          <span class="text-danger">
            Sólo en formato PDF
          </span>
        </div>
        <div class="col-md-6" v-if="Object.keys(step.mainFile).length">
          <div class="d-flex flex-row align-items-center">
            <vs-icon icon="description" size="45px" color="primary" />
            <b class="text-truncate w-100">{{ step.mainFile.name }}</b>
          </div>
        </div>
      </div>
      <div class="row mb-3 mt-3">
        <div class="col-md-3 d-flex align-items-end">
          <UploadFile
            permission="*"
            text="Cargar Archivos Adjuntos"
            accept="application/pdf"
            v-model="additionalFile"
            upload-to="ed"
            button-class="btn-block"
            container-class="w-100"
            @input="addAdditionalFile()"
          />
        </div>
        <div class="col-3" v-for="file in step.attachments" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="45px" color="primary" />
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="removeAdditionalFile(file.id)"
            />
          </div>
        </div>
      </div>
    </form>
    <form data-vv-scope="flow-part-2" @submit.prevent="() => false">
      <div class="row mb-3 mt-4" v-if="step.executionType === 'P'">
        <div class="col-12">
          <h4>Detalle del flujo</h4>
        </div>
      </div>
      <small class="text-primary" v-if="searchingFlow">
        Estamos buscando la información sobre el flujo que seleccionaste
      </small>
      <StepsOldFlow v-if="step.oldFlow && oldFlow.pasos" :steps="oldFlow.pasos" />
      <div class="row mt-4 mb-5" v-if="!step.oldFlow">
        <div class="col-3 mt-3">
          <vs-select
            class="w-100"
            autocomplete
            label="Tipo de paso (*)"
            name="stepType"
            data-cy="stepType"
            v-model="stepType"
            :danger="errors.has('flow-part-2.stepType')"
            :danger-text="errors.first('flow-part-2.stepType')"
            v-validate="'required'"
            @change="searchOffice"
          >
            <vs-select-item
              :value="stepTypes.USER"
              text="Usuario"
            />
            <vs-select-item
              :value="stepTypes.GROUP"
              text="Grupo"
            />
            <vs-select-item
              :value="stepTypes.OFFICE"
              text="Oficina"
            />
            <vs-select-item
              :value="stepTypes.EXTERNAL"
              text="Externo"
            />
          </vs-select>
        </div>
        <div
          class="col-6 mt-3"
          v-if="stepType === stepTypes.GROUP"
        >
          <list-groups
            class="w-100"
            autocomplete
            label="Grupo del responsable (*)"
            name="groupStep"
            v-model="groupStep"
            :typeList="stepType"
            ref="groupStep"
            :danger="errors.has('flow-part-2.groupStep')"
            :danger-text="errors.first('flow-part-2.groupStep')"
            v-validate="{ required: stepType === stepTypes.GROUP }"
          />
        </div>
        <div
          class="col-6 mt-3"
          v-if="stepType === this.stepTypes.OFFICE"
        >
          <list-offices
            class="w-100 mb-1"
            autocomplete
            label="Oficina del responsable (*)"
            name="groupStep"
            v-model="groupStep"
            data-vv-as="oficina"
            :typeList="stepType"
            validate-lider
            withFilters
            officeType="int"
            ref="groupStep"
            :danger="errors.has('flow-part-2.groupStep')"
            :danger-text="errors.first('flow-part-2.groupStep')"
            v-validate="{ required: stepType === this.stepTypes.OFFICE }"
          />
          <small class="text-danger">
            Si le falta una oficina, favor notificar al equipo de Soporte
            para que verifiquen que esté correctamente configurada
          </small>
        </div>
        <div
          class="col-6 mt-3"
          v-if="stepType === stepTypes.USER"
        >
          <list-user
            class="w-100"
            autocomplete
            label="Usuario (*)"
            name="userStep"
            v-model="userStep"
            ref="userStep"
            :danger="errors.has('flow-part-2.userStep')"
            :danger-text="errors.first('flow-part-2.userStep')"
            v-validate="{ required: stepType === stepTypes.USER }"
          />
        </div>
        <div
          class="col-4 mt-3"
          v-if="stepType === stepTypes.EXTERNAL"
        >
          <vs-input
            class="w-100"
            label="Rut empresa o institución (*)"
            name="companyIut"
            placeholder="12345678-9"
            autocomplete="off"
            v-model="step.extern.iut"
            :danger="errors.has('flow-part-2.companyIut')"
            :danger-text="errors.first('flow-part-2.companyIut')"
            v-validate="{ required: stepType === stepTypes.EXTERNAL }"
          />
        </div>
        <div
          class="col-1 text-center mt-3"
          v-if="stepType === stepTypes.EXTERNAL"
        >
          <b-overlay :show="loadingCompany">
            <b-button
              v-tooltip="'Buscar empresa'"
              variant="primary"
              class="btn-icon rounded-circle p-3 mt-5"
              size="sm"
              v-on:click="searchCompanyIut()"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>
          </b-overlay>
        </div>
        <div
          class="col-4 mt-3"
          v-if="externCompany.iut && stepType === stepTypes.EXTERNAL"
        >
          <vs-input
            class="w-100"
            label="Razón empresa (*)"
            v-model="externCompany.razonSocial"
            name="razonSocial"
            :danger="errors.has('flow-part-2.razonSocial')"
            :danger-text="errors.first('flow-part-2.razonSocial')"
            v-validate="{ required: stepType === stepTypes.EXTERNAL }"
          />
        </div>
        <div
          class="col-4 mt-3"
          v-if="externCompany.iut &&
          (!newCompany && externCompany.users && externCompany.users.length) &&
           stepType === stepTypes.EXTERNAL"
        >
          <div>
            Posibles firmantes
            <b-button
              v-tooltip="'Ver usuarios de la empresa'"
              variant="secondary"
              class="btn-icon rounded-circle p-3 mt-5"
              size="sm"
              v-b-modal="'users-extern-company'"
            >
              <feather-icon icon="UsersIcon" />
            </b-button>
          </div>
        </div>
        <div class="col-4 mt-3" v-if="externCompany.iut && stepType === stepTypes.EXTERNAL">
          <vs-input
            class="w-100"
            label="Rut del firmante (*)"
            v-model="step.extern.responsibleIut"
            name="responsibleIut"
            :danger="errors.has('flow-part-2.responsibleIut')"
            :danger-text="errors.first('flow-part-2.responsibleIut')"
            v-validate="{ required: stepType === stepTypes.EXTERNAL }"
          />
        </div>
        <div class="col-4 mt-3" v-if="externCompany.iut && stepType === stepTypes.EXTERNAL">
          <vs-input
            class="w-100"
            label="Nombre del firmante (*)"
            v-model="step.extern.responsibleName"
            name="responsibleName"
            :danger="errors.has('flow-part-2.responsibleName')"
            :danger-text="errors.first('flow-part-2.responsibleName')"
            v-validate="{ required: stepType === stepTypes.EXTERNAL }"
          />
        </div>
        <div class="col-4 mt-3" v-if="externCompany.iut && stepType === stepTypes.EXTERNAL">
          <vs-input
            class="w-100"
            label="Correo del firmante (*)"
            v-model="step.extern.responsibleEmail"
            name="responsibleEmail"
            :danger="errors.has('flow-part-2.responsibleEmail')"
            :danger-text="errors.first('flow-part-2.responsibleEmail')"
            v-validate="{ required: stepType === stepTypes.EXTERNAL }"
          />
        </div>
        <div
          class="col-4 mt-3 text-primary"
          v-if="stepType === stepTypes.EXTERNAL"
        >
          <ul>
            <li>- Este tipo de paso será <b>firmante</b></li>
            <li>- Este tipo de firma será <b>firma avanzada</b></li>
          </ul>
        </div>
        <div
          class="col-3 mt-3"
          v-if="stepType !== stepTypes.OFFICE && stepType !== stepTypes.EXTERNAL"
        >
          <b-form-group label="Tipo de rol (*)">
            <v-select
              id="rolType"
              label="label"
              :options="rolTypesOption"
              :reduce="rol => rol.id"
              name="rolType"
              v-model="rolType"
              :class="{ danger: errors.has('flow-part-2.rolType') }"
              v-validate="'required'"
            />
            <InfoRolType/>
            <span
              v-show="errors.has('flow-part-2.rolType')"
              class="danger span-text-validation-danger v-enter-to"
            >
              {{ errors.first('flow-part-2.rolType') }}
            </span>
          </b-form-group>
        </div>
        <div class="col-3 mt-3" v-if="stepType === stepTypes.OFFICE">
          <b-form-group
            label="Tipo de rol (*)"
          >
            <v-select
              label="label"
              :options="rolTypesOfficeOption"
              :reduce="rol => rol.id"
              name="rolType"
              v-model="rolType"
              :class="{ danger: errors.has('flow-part-2.rolType') }"
              v-validate="'required'"
            />
            <div class="text-right">
              info
              <b-button
                size="sm"
                class="btn-icon rounded-circle mt-1"
                id="popover-button"
                variant="flat-primary"
              >
                <feather-icon icon="InfoIcon" />
              </b-button>
              <b-popover
                target="popover-button"
                triggers="focus"
                placement="top"
              >
                <template #title>
                  <span>Tipos de roles!</span>
                </template>
                <span>
                  <b>+ Numerar/tramitar:</b> Permite firmar documentos, esto cuenta como
                  la aprobación, se coloca un estampado de numeración o trámite.
                </span>
              </b-popover>
            </div>
            <span
              v-show="errors.has('flow-part-2.rolType')"
              class="danger span-text-validation-danger v-enter-to"
            >
              {{ errors.first('flow-part-2.rolType') }}
            </span>
          </b-form-group>
        </div>
      </div>
      <div class="row mb-3" v-if="!step.oldFlow">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <vs-button
            color="primary"
            icon="add"
            :disabled="blockButton"
            v-on:click="addStep()"
            data-cy="add-step"
          >
            Agregar Paso
          </vs-button>
        </div>
      </div>
      <StepsFlow :steps="step.steps" @remove-step="removeStep" />
      <div
        v-if="error.message !== ''"
        class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
           style="height: 32px;">
        <span class="span-text-validation">
          {{error.message}}
        </span>
      </div>
    </form>
    <b-modal
      id="users-extern-company"
      ref="usersExternCompany"
      :title="`Usuarios de la empresa ${externCompany.iut}`"
      cancel-title="Cancelar"
      size="lg"
    >
      <div style="height: 500px;overflow: scroll;">
        <h5>Estos usuarios ya existen en la empresa</h5>
        <div
          style="cursor: pointer;"
          v-for="user in externCompany.users" :key="user.id"
          class="employee-task mb-2 d-flex justify-content-between align-items-center step-box"
          v-on:click="selectUser(user)"
        >
          <b-media no-body>
            <b-media-aside class="mr-75">
              <b-avatar
                rounded
                v-if="user.id"
                :text="user.nombre | avatarName"
                size="42"
                class="mt-25 mr-75"
              />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h5 class="mb-0">
                {{ user.nombre }}
              </h5>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <small class="text-muted mr-75">
              {{ user.correo }}
            </small>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListUser from '@/febos/chile/lists/components/ListUser';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import StepsFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/StepsFlow';
import StepsOldFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/StepsOldFlow';
import { getUsersByGroup, ioGetCompanies } from '@/febos/servicios/api/empresas.api';
import { getApprovalTemplate } from '@/febos/servicios/api/aprobaciones.api';
import { getUsers } from '@/febos/servicios/api/usuarios.api';
import {
  rolTypes,
  stepTypes
} from '@/febos/chile/approvals/components/trays/managementTray/constants';
import InfoRolType from '@/febos/chile/approvals/wizardFlow/components/InfoRolType';
import SignatureTypes from '@/febos/chile/dnt/mixins/SignatureTypes';

export default {
  mixins: [WizardStep],
  components: {
    InfoRolType,
    ListGroups,
    ListUser,
    ListOffices,
    UploadFile,
    StepsFlow,
    StepsOldFlow
  },
  data() {
    return {
      error: {
        message: ''
      },
      externCompany: {
        users: []
      },
      rolTypesOfficeOption: [
        { id: RolTypes.SIGNER, label: 'Numerar/Tramitar' }
      ],
      searchingFlow: false,
      newCompany: false,
      newUserCompany: false,
      loadingCompany: false,
      oldFlow: {},
      rolTypes: RolTypes,
      stepTypes: StepTypes,
      typeDocuments: [],
      step: {
        fileId: this.$route.params.id,
        extern: {},
        documentType: '',
        pdfStamp: true,
        mainFile: {},
        executionType: '',
        objectType: 'ARCHIVO',
      },
      stepType: StepTypes.USER,
      additionalFile: {}
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'step.flowId': async function (newValue) {
      if (newValue && newValue.length) {
        this.searchingFlow = false;
        this.oldFlow.pasos = [];
        const flow = this.approvalsTemplates.find((selected) => selected.id === newValue);
        this.searchingFlow = true;
        const response = await this.searchApprovalTemplate(newValue);
        this.searchingFlow = false;
        this.oldFlow = response.data.aprobacion;
        if (flow) {
          this.step.executionType = flow.tipoEjecucion;
          this.step.objectType = flow.tipoObjeto;
        } else {
          this.step.executionType = '';
          this.step.objectType = '';
        }
      }
    }
  },
  computed: {
    ...mapGetters('List', [
      'groupUsersState',
      'userGroupsState'
    ]),
    ...mapGetters('Approvals', [
      'approvalsTemplates'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    ...mapActions('Approvals', [
      'getApprovalsTemplates'
    ]),
    selectUser(user) {
      this.newUserCompany = false;
      this.step = {
        ...this.step,
        extern: {
          iut: this.externCompany.iut,
          responsibleName: user.nombre,
          responsibleIut: user.iut,
          responsibleEmail: user.correo
        }
      };
      this.$refs.usersExternCompany.hide();
    },
    async searchCompanyIut() {
      this.loadingCompany = true;
      const { data } = await ioGetCompanies({
        pagina: 1,
        filas: 100,
        filtro: this.step.extern.iut.includes('-')
          ? `iut$${this.step.extern.iut.split('-')[0]}` : `iut$${this.step.extern.iut}`,
        simular: 'no',
        usaFiltros: 'si',
        busquedaSimple: 'no',
        ambito: 'cloud'
      });
      this.loadingCompany = false;
      if (data.empresas && data.empresas.length) {
        const [companies] = data.empresas;
        this.newCompany = false;
        this.externCompany = companies;
        const response = await getUsers({
          buscarEnEmpresaId: this.externCompany.id,
          filas: 10000,
          pagina: 1
        });
        this.externCompany = { ...this.externCompany, users: response.data.usuarios };
      } else {
        this.newCompany = true;
        this.newUserCompany = true;
        this.externCompany = {
          iut: this.step.extern.iut,
          users: []
        };
      }
    },
    async addAdditionalFile() {
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.step.attachments.push(this.additionalFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.step.attachments = this.step.attachments.filter((file) => file.id !== fileId);
    },
    addFile() {
      if (this.step.mainFile.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        this.step.mainFile = {};
      }
    },
    async searchApprovalTemplate(approvalId) {
      this.searchingFlow = true;
      const response = await getApprovalTemplate({
        id: approvalId,
        estado: true
      });
      this.searchingFlow = false;
      return response;
    },
    searchOffice() {
      if (this.stepType === StepTypes.OFFICE) {
        const typeOffice = 'int';
        const offices = this.userGroupsState.list
          .filter((group) => group.isOffice === 'Y' && group.type === typeOffice);
        if (offices.length) {
          this.groupStep = offices[0].id;
        }
      }
    },
    removeStep(stepRemove) {
      this.blockButton = false;
      this.error.message = '';
      this.step.steps = this.step.steps
        .filter((step) => step.stepNumber !== stepRemove.stepNumber)
        .map((stepMap, index) => ({
          ...stepMap,
          stepNumber: index + 1
        }));
    },
    async addExternStep() {
      const isExistentUser = this.externCompany.users && this.externCompany.users.length
        && this.externCompany.users.some((user) => user.iut === this.step.extern.responsibleIut);
      const step = {
        esNuevaEmpresa: this.newCompany,
        esNuevoUsuario: this.newCompany ? true : !isExistentUser,
        data: {
          grupoUsuarios: [],
          tipoValorResponsableId: this.step.extern.iut + (this.step.steps.length + 1),
          responsable: {
            correo: this.step.extern.responsibleEmail,
            nombre: this.step.extern.responsibleName,
            rut: this.step.extern.responsibleIut
          },
          aprobacionesTipoRolId: this.rolTypes.SIGNER,
          aprobacionesTipoPasoId: this.stepType,
          tipoPaso: {
            id: this.stepType,
            nombre: stepTypes[this.stepType],
          },
          tipoRol: {
            id: this.rolTypes.SIGNER,
            nombre: rolTypes[this.rolTypes.SIGNER],
          },
          index: this.step.steps.length + 1,
          extra: {
            empresa: {
              iut: this.step.extern.iut,
              razon: this.externCompany.razonSocial
            }
          }
        },
        stepType: this.stepType,
        rolType: this.rolTypes.SIGNER,
        stepNumber: this.step.steps.length + 1,
        responsibleName: this.step.extern.responsibleName,
        responsibleId: this.step.extern.responsibleIut,
        responsibleEmail: this.step.extern.responsibleEmail,
        tipoFirma: SignatureTypes.FEA
      };

      this.step.steps.push(step);

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.step.extern = {};
      this.externCompany = {};
      this.blockButton = false;
      await this.$validator.reset();
    },
    async addStep() {
      this.error.message = '';
      this.blockButton = true;
      const isValid = await this.validateForm('flow-part-2');

      if (!isValid) {
        this.blockButton = false;
        return;
      }

      if (this.stepType === StepTypes.EXTERNAL) {
        await this.addExternStep();
        return;
      }

      const responsibleStep = (
        this.stepType === StepTypes.GROUP || this.stepType === StepTypes.OFFICE
      )
        ? this.$refs.groupStep.getOption()
        : this.$refs.userStep.getOption();

      const step = {
        stepType: this.stepType,
        rolType: this.rolType,
        stepNumber: this.step.steps.length + 1,
        responsibleName: responsibleStep.label,
        responsibleId: responsibleStep.id,
        responsibleEmail: responsibleStep.email || ''
      };

      if (this.stepType === StepTypes.GROUP || this.stepType === StepTypes.OFFICE) {
        const { data: { usuarios: users } } = await getUsersByGroup({
          empresaId: this.company.id,
          pagina: 1,
          filas: 9999,
          groupId: responsibleStep.id
        });

        step.groupUsers = users.map((user) => ({
          ...user,
          tipoValorResponsableId: user.id
        }));
      }

      this.step.steps.push(step);

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.blockButton = false;
      await this.$validator.reset();
    },
    async isValid() {
      this.blockButton = false;
      this.error.message = '';
      const flowValidation = await Promise.all([
        this.validateForm('flow-part-1')
      ]);

      if (flowValidation.some((step) => !step)) {
        return false;
      }

      if (!this.step.steps.length && !this.step.oldFlow) {
        this.error.message = 'Debes agregar al menos un paso';
        return false;
      }

      if (!this.step.mainFile.name) {
        this.error.message = 'Debes agregar el documento para el flujo';
        return false;
      }

      if (
        !this.step.oldFlow
        && this.step.steps[this.step.steps.length - 1].rolType === this.rolTypes.REVIEWER
      ) {
        this.error.message = 'El último paso no puede ser revisor';
        return false;
      }

      const officeId = (this.step.steps
        .find((step) => step.stepType === this.stepTypes.OFFICE) || {}).responsibleId;

      if (!officeId) {
        this.error.message = 'Debes ingresar una oficina en los pasos para el flujo';
        return false;
      }

      return true;
    },
    getStepData() {
      this.error.message = '';
      this.blockButton = false;
      return {
        ...this.step
      };
    }
  },
  async created() {
    this.blockButton = false;
    this.searchingFlow = false;
    await this.fetchUserGroups();
    this.getApprovalsTemplates({
      params: {
        filtros: `iutEmpresa:${this.company.id}|aprobacionesEstado:Y|filtrarUnidad:Y|tipoObjeto:ARCHIVO`,
        pagina: 1,
        orden: '-fechaCreacion',
        itemsPorPagina: 2000,
      }
    });
  }
};
</script>
<style>

.vs--single .vs__dropdown-toggle {
  padding: 6px !important;
}
.annotationLayer {
  position: absolute !important;
  border-bottom: 1px solid #c3c3c3;
}

.linkAnnotation {
  transform: unset !important;
  transform-origin: unset !important;
  left: unset !important;
  top: unset !important;
  right: 0 !important;
  bottom: 0 !important;
}

.selected {
  background-color: rgba(116, 74, 135, 0.49);
  border: 1px solid rgb(230 191 247);
}

.manage-comments {
  bottom: 60px;
}
.container-attachment {
  max-height: 55vh;
  overflow-y: scroll;
}
.container-actions {
  height: 350px;
  overflow-y: scroll;
}

.container-pdf {
  max-height: 85vh;
  overflow-y: auto;
}
.page {
  height: auto;
  margin: 0 auto;
}

</style>
